import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { useMemo } from 'react';
import { buildID } from '../../../data/utilities/Concatenation';
import { useHighlight } from '../../highlight';
import SignalDeltaLine from '../SignalDeltaLine';
function SignalCrosshair({ signal }) {
    const highlightIDsX = useMemo(() => {
        return [buildID(signal.id, 'Crosshair'), buildID(signal.id, 'Crosshair_X')];
    }, [signal.id]);
    const highlightIDsY = useMemo(() => {
        return [buildID(signal.id, 'Crosshair'), buildID(signal.id, 'Crosshair_Y')];
    }, [signal.id]);
    const highlightX = useHighlight(highlightIDsX);
    const highlightY = useHighlight(highlightIDsY);
    const highlight = useHighlight([signal.id]);
    if (!signal?.x?.delta || !signal?.y?.delta)
        return null;
    return (_jsxs("g", { children: [_jsx(SignalDeltaLine, { delta: signal.x.delta, axis: "X", show: highlightX.isActive || highlight.isActive }), _jsx(SignalDeltaLine, { delta: signal.y.delta, axis: "Y", show: highlightY.isActive || highlight.isActive })] }));
}
export default SignalCrosshair;
